import {createResourcesProxy, waitForCSS} from '@parcel/runtime-rsc/rsc-helpers';
import {preinit} from 'react-dom';
preinit(parcelRequire.resolve("lC5w8"), {as: 'style', precedence: 'default'});
let promise = Promise.all([parcelRequire.load("iGMXi"), parcelRequire.load("g56vt"), parcelRequire.load("lzjui"), parcelRequire.load("jqxBu"), parcelRequire.load("3YuHm"), parcelRequire.load("6e0ex")]).then(() => {
let originalModule = parcelRequire("j5Ve0");
let resources = <>
  <link rel="modulepreload" href={parcelRequire.resolve("iGMXi")} />
  <link rel="modulepreload" href={parcelRequire.resolve("g56vt")} />
  <link rel="modulepreload" href={parcelRequire.resolve("lzjui")} />
  <link rel="stylesheet" href={parcelRequire.resolve("lC5w8")} precedence="default" />
  <link rel="modulepreload" href={parcelRequire.resolve("jqxBu")} />
  <link rel="modulepreload" href={parcelRequire.resolve("3YuHm")} />
  <link rel="modulepreload" href={parcelRequire.resolve("6e0ex")} />
</>;
let res = createResourcesProxy(originalModule, false, resources );
  return res;
});
module.exports = promise;
